<script lang="ts">
import layout from '~/consumer/layouts/DefaultLayout.vue'
export default { layout }

</script>
<script lang="ts" setup>
import DefaultLayout from '@consumer/layouts/DefaultLayout.vue'
import SupportLayout from '@consumer/layouts/SupportLayout.vue'
import ArticlePage from '@consumer/modules/support/ArticlePage.vue'
import type { Gift, PurchasedOrder } from '@consumer/types/serializers'
import type { SupportArticle, SupportCategory } from '@consumer/types/SupportArticle'

defineOptions({
  layout: [DefaultLayout, SupportLayout],
})

const props = defineProps<{
  currentCategory: SupportCategory
  currentArticle: SupportArticle
  order?: PurchasedOrder
  gift?: Gift
}>()
</script>

<template>
  <Head>
    <title>{{ currentCategory.label }} | Giftly Help Center</title>
  </Head>

  <ArticlePage v-bind="props"/>
</template>
